export const GET_SERVER_LIST = 'GET_SERVER_LIST'
